import { render } from "./YourProfile.vue?vue&type=template&id=0b7b4b65&ts=true"
import script from "./YourProfile.vue?vue&type=script&lang=ts"
export * from "./YourProfile.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/Spark/Spark/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__